$(function () {
    // open zopim chat by clicking any chat link
    if (typeof $zopim !== 'undefined') {
        $zopim(function () {
            $zopim.livechat.setLanguage('en');
        });
    }
    $(document).on('click', '.chat-link', function (e) {
        e.preventDefault();

        if (typeof $zopim === 'undefined') {
            //  non-prod environment or loading error
            console.info('Zopim chat is disabled');
            return;
        }

        $zopim(function () {
            $zopim.livechat.window.show();
        });
    });


    // demo videos block
    var swiperVideos = new Swiper('.videos_container', {
        loop: true,
        slidesPerView: 'auto', //'3',
        centeredSlides: true,
        spaceBetween: 0,
        nextButton: '.videos_container .swiper-button-next',
        prevButton: '.videos_container .swiper-button-prev',
        grabCursor: true
    });
    $('.videos_block').hover(swiperVideos.stopAutoplay, swiperVideos.startAutoplay);


    $(".youtube_video").each(function() {
        // Based on the YouTube ID, we can easily find the thumbnail image
        $(this).css('background-image', 'url(https://i.ytimg.com/vi/' + this.id + '/sddefault.jpg)');

        // Overlay the Play icon to make it look like a video player
        $(this).append($('<div/>', {'class': 'play'}));

        $(document).delegate('#'+this.id, 'click', function() {
            // Create an iFrame with autoplay set to true
            var iframe_url = "https://www.youtube.com/embed/" + this.id + "?autoplay=1&autohide=1";
            if ($(this).data('params')) iframe_url+='&'+$(this).data('params');

            // The height and width of the iFrame should be the same as parent
            var iframe = $('<iframe/>', {'frameborder': '0', 'src': iframe_url, 'width': $(this).width(), 'height': $(this).height(), 'allow': 'autoplay;', 'allowfullscreen': '' });

            // Replace the YouTube thumbnail with YouTube HTML5 Player
            $(this).replaceWith(iframe);
        });
    });
});